import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { topContentViewsApi } from "../../constants/apiConstants";
import request from "../../utils/request";

export const topContentViews = createAsyncThunk(
    "topContentViewsReducer/topContentViews",

    async(payload)=>{
        try{
            const res = await request({
                url: topContentViewsApi.topContentViews,
                method: "POST",
                data: payload, 
           });
           
            return res;
        }
        catch (error) {
            console.error("Top Content Views fetch is failed:", error);
            throw error;
          }
    }
)

const topContentByViewsSlice = createSlice({
    name: "topContentViews",
    initialState:{
        getTopContentViewsReq : null,
        isgetTopContentViewsLoading:false

    },
    reducers:{
        topContentByViewsRes: (state, action) => {
            state.getTopContentViewsReq = action.payload;
         },
    },
    extraReducers: (builder) => {
               builder
                 .addCase(topContentViews.pending, (state) => {
                  state.isgetTopContentViewsLoading = true;
                  
                 })
                 .addCase(topContentViews.fulfilled, (state,action) => {
                  state.isgetTopContentViewsLoading = false;
                  state.getTopContentViewsReq = action.payload;
                 })
                 .addCase(topContentViews.rejected, (state,action) => {
                  state.isgetTopContentViewsLoading = false;
                 });
             },
})

export const { topContentByViewsRes } = topContentByViewsSlice.actions;
export default topContentByViewsSlice.reducer;